import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/app/routes';
import { AuthLayout } from '../components/AuthLayout';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm';
import { useForgotPasswordMutation } from '../api/authApi';
import { useTranslations } from '@/hooks';

// The backend's forgotPassword endpoint always responds 200 with the same generic.
export const ForgotPasswordPage = () => {
  const t = useTranslations();
  const navigate = useNavigate();

  const handleBackToLogin = useCallback(() => {
    navigate(ROUTES.login);
  }, [navigate]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [forgotPassword, { isLoading, error }] = useForgotPasswordMutation();

  const handleSubmit = async ({ email }) => {
    setSuccessMessage(null);
    const result = await forgotPassword(email);
    if (result.error) return;
    setSuccessMessage(result.data?.message ?? t('AUTH_RESET_EMAIL_SENT'));
  };

  return (
    <AuthLayout>
      <ForgotPasswordForm
        onSubmit={handleSubmit}
        onBackToLogin={handleBackToLogin}
        isLoading={isLoading}
        error={error}
        successMessage={successMessage}
      />
    </AuthLayout>
  );
};
